import request from '@/utils/request';
export const defaultSchemesDiscountData = {
  id: 0,
  enabled: true,
  nettDiscount: 0,
  percentDiscount: 0,
  schemeId: null,
  scheme: {
    id: null
  },
  stateId: null,
  state: {
    id: null
  },
  agentId: null,
  agent: {
    id: null
  },
  rangeId: null,
  range: {
    id: null
  },
  categoryId: null,
  category: {
    id: null
  },
  subCategoryId: null,
  subCategory: {
    id: null
  },
  dealersRoleId: null,
  dealersRole: {
    id: null
  },
  productId: null,
  product: {
    id: null
  },
  productsVariationId: null,
  productsVariation: {
    id: null
  },
  schemesCategoryId: null,
  schemesCategory: {
    id: null
  }
};
export const getSchemesDiscounts = params => request({
  url: '/schemes-discounts',
  method: 'get',
  params
});
export const getSchemesDiscountById = id => request({
  url: `/schemes-discounts/${id}`,
  method: 'get'
});
export const updateSchemesDiscount = (id, data) => request({
  url: `/schemes-discounts/${id}`,
  method: 'patch',
  data
});
export const deleteSchemesDiscount = id => request({
  url: `/schemes-discounts/${id}`,
  method: 'delete'
});
export const createSchemesDiscount = data => request({
  url: '/schemes-discounts',
  method: 'post',
  data
});
export const manageSchemesDiscount = data => request({
  url: '/schemes-discounts/manage',
  method: 'post',
  data
});